import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { Reveal } from '../Reveal';
import { PRICING, PRICING_OPTIONS } from '../../data/content';
const ASSURANCES = ['Acceso inmediato', 'Pago único', 'Garantía de 7 días', 'Acceso de por vida'];
export function FinalClose({
  onCta
}: {
  onCta: () => void;
}) {
  const megapack = PRICING_OPTIONS[0];
  return <section className="w-full px-5 py-12 sm:py-16" data-id="element-80" data-mp="2o4h8mqlvk34z">
      <div className="mx-auto max-w-2xl text-center" data-id="element-81" data-mp="2o7v9fuew44ab">
        <Reveal data-id="element-82" data-mp="2t3amik52pw5o">
          <h2 className="font-display text-2xl leading-tight text-snow sm:text-4xl" data-id="element-83" data-mp="2t2sih1c66dn7">
            ¿Lista para <span className="u-lime" data-id="element-84" data-mp="2x709j563o5ol">dejar de improvisar</span> cada semana?
          </h2>
          <p className="mx-auto mt-3 max-w-lg text-sm leading-relaxed text-snow-muted sm:text-base" data-id="element-85" data-mp="324rzvur3jjqo">
            No necesitás seguir perdiendo horas armando desde cero algo que podés tener organizado y listo para
            consultar.
          </p>
        </Reveal>

        {megapack && <Reveal delay={90} className="mt-8" data-id="element-86" data-mp="1tk84ihjxn5g7">
            <div className="rounded-3xl border-2 border-lime bg-rose-deep px-6 py-8 sm:px-10" data-id="element-87" data-mp="1tl13uxgkasob">
              <p className="text-sm text-snow-muted" data-id="element-88" data-mp="1oqdfcylk5y9q">Con MegaPack Árabe PRO recibís:</p>
              <p className="mt-1.5 text-base font-bold text-snow sm:text-lg" data-id="element-89" data-mp="1kr4ivlz4vmah">
                6 contenidos completos <span className="text-lime" data-id="element-90" data-mp="1fpoxfst1ndrk">+ 5 bonos exclusivos</span>
              </p>

              <p className="mt-5 text-sm font-semibold text-snow-muted line-through" data-id="element-91" data-mp="2ch9c8a4vfjnu">{PRICING.totalValueOld}</p>
              <p className="mt-1 font-display text-5xl leading-none text-snow" data-id="element-92" data-mp="28ecns2sngtbz">{megapack.price}</p>

              <CtaButton variant="lime" className="mt-6 w-full max-w-sm" onClick={onCta} data-id="element-93" data-mp="23jgu6y7rlxwr">
                Quiero MegaPack Árabe PRO <ArrowRightIcon className="h-4 w-4 flex-shrink-0" aria-hidden="true" data-id="element-94" data-mp="s27coh875fy3" />
              </CtaButton>

              <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2" data-id="element-95" data-mp="n3dxmkd9hgvt">
                {ASSURANCES.map(item => <li key={item} className="inline-flex items-center gap-1.5 text-xs font-bold text-snow" data-id="element-96" data-mp="ojrt5mwp164k">
                    <CheckIcon className="h-3.5 w-3.5 text-lime" aria-hidden="true" data-id="element-97" data-mp="tjmi3kwwrlmz" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </Reveal>}

        <Reveal delay={140} className="mt-9" data-id="element-98" data-mp="ki6im87mt3xj">
          <p className="font-display text-xl leading-snug text-snow sm:text-2xl" data-id="element-99" data-mp="kgv3jc8qk9r4">
            Menos tiempo pensando qué enseñar.
            <br data-id="element-100" data-mp="akib0hoxg1xy" />
            <span className="u-lime" data-id="element-101" data-mp="al1ui2u86ye3">Más tiempo enseñando.</span>
          </p>
        </Reveal>
      </div>
    </section>;
}